import { render, staticRenderFns } from "./ApplicationsListSimplified.vue?vue&type=template&id=136361e4&"
import script from "./ApplicationsListSimplified.vue?vue&type=script&lang=js&"
export * from "./ApplicationsListSimplified.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationsListSimplified.vue?vue&type=style&index=0&id=136361e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports